import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "app/lib/utils";

interface Props {
  onClick: () => void;
  size?: "small" | "medium" | "large";
  className?: string;
}

export default function CircleEditButton({
  onClick,
  size,
  className,
}: Readonly<Props>) {
  return (
    <button onClick={onClick} type="button" className="no-style-button">
      <div className={cn(`edit-circle`, size, className)}>
        <FontAwesomeIcon icon="edit" />
      </div>
    </button>
  );
}
